export const styles = {
  root: {
    flexGrow: 1,
  },
  header: {
    backgroundColor: "#123C69",
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxWidth: '100%',
  },
  logout: {
    color: '#123C69',
    fontWeight: 'bold',
    margin: 10,
    height: 40,
    borderRadius: 4,
    border: '2px solid white',
    padding: 12,
    '&:hover': {
      cursor: 'pointer'
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/header/style.js